import { render } from "./IconSun.vue.js?vue&type=template&id=398ed1b8!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconSun.vue?vue&type=template&id=398ed1b8"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__